import React from "react";
export const ItemLayout = (props: any) => (
  <div className="ting-header md:text-md mt-10 mb-2 px-4">{props.children}</div>
);
